import axiosInstance, { statisticsAxiosInstance } from './axios';

//관리자
export const getUser = (userId) => {
    return axiosInstance.get(`/users/${userId}`);
};

// 시설유형 목록 조회 (매니저)
export const getFacilityTypeList = () => {
    return axiosInstance.get('/facility-type');
};

// 대시보드 통계 요약
export const getStatisticsSummary = (params) => {
    return statisticsAxiosInstance.get('/statistics/summary', { params });
};

// 미점검 현황 시설별 목록
export const getNotCheckedFacilityList = (params) => {
    return statisticsAxiosInstance.get('/statistics/not-checked/facility-list', { params });
};

// 미점검 현황 점검자별 목록
export const getNotCheckedCheckerList = (params) => {
    return statisticsAxiosInstance.get('/statistics/not-checked/checker-list', { params });
};

// 고객의소리 접수 현황 목록
export const getComplaintList = (params) => {
    return statisticsAxiosInstance.get('/statistics/complaint/list', { params });
};

// 고장A/S 접수 현황 목록
export const getIssueList = (params) => {
    return statisticsAxiosInstance.get('/statistics/issue/list', { params });
};

// 점검강제등록 현황 시설별 목록
export const getForcedFacilityList = (params) => {
    return statisticsAxiosInstance.get('/statistics/forced/facility-list', { params });
};

// 점검강제등록 현황 점검자별 목록
export const getForcedCheckerList = (params) => {
    return statisticsAxiosInstance.get('/statistics/forced/checker-list', { params });
};

// 엑셀 다운로드
export const downloadSummaryExcel = (params) => {
    return statisticsAxiosInstance.get('/statistics/excel/summary', { params, responseType: 'blob' });
};

export const downloadNotCheckedExcel = (params) => {
    return statisticsAxiosInstance.get('/statistics/excel/not-checked', { params, responseType: 'blob' });
};

export const downloadComplaintExcel = (params) => {
    return statisticsAxiosInstance.get('/statistics/excel/complaint', { params, responseType: 'blob' });
};

export const downloadIssueExcel = (params) => {
    return statisticsAxiosInstance.get('/statistics/excel/issue', { params, responseType: 'blob' });
};

export const downloadForcedExcel = (params) => {
    return statisticsAxiosInstance.get('/statistics/excel/forced', { params, responseType: 'blob' });
};
